import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Grid from 'react-bootstrap/lib/Grid';

import { loadOrder } from 'actions';
import { allCitiesSelector, bikeTypesSelector } from 'selectors';
import Preloader from 'widgets/Preloader';
import BookingResultScreen from 'widgets/BookingResultScreen';
import ShareLinks from 'widgets/ShareLinks';
import SubscribeFormSection from 'widgets/SubscribeFormSection';

import './order-success.css';

class SuccessPage extends Component {
  componentWillMount() {
    this.props.loadOrder(this.props.params.orderUid);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.orderUid !== this.props.orderUid) {
      this.props.loadOrder(nextProps.params.orderUid);
    }
  }

  render() {
    const { t, order: { isFetching, item: order } } = this.props;
    return (
      <div className="order-success-page">
        <Grid>
          <div className="order-success-box">
            {(isFetching) &&
              <Preloader cubeStyle={{ backgroundColor: '#5080c5' }} />
            }

            {(order) &&
              <BookingResultScreen
                success={true}
                order={order}
                cities={this.props.cities}
                bikeTypes={this.props.bikeTypes}
                contactEmail={this.props.contactEmail}
              />
            }
          </div>
        </Grid>

        <div className="order-success-share-links">
          <h3>
            {t('Tell your friends about BikesBooking!')}<br />
            {t('We are happy when you are happy:')}
          </h3>

          <ShareLinks
            title={t('title', { ns: 'meta' })}
            description={t('description', { ns: 'meta' })}
          />
        </div>

        <SubscribeFormSection />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    order: state.order.order,
    contactEmail: state.app.siteConfig.contactEmail,
    cities: allCitiesSelector(state),
    bikeTypes: bikeTypesSelector(state)
  };
}

export default connect(mapStateToProps, { loadOrder })(translate(['translation'])(SuccessPage));



// WEBPACK FOOTER //
// ./src/components/OrderSuccessPage/index.js